import Button from '@/storybook/components/Button/Button';
import styles from './SingleDatePickerFooter.module.css';

type SingleDatePickerFooterProps = {
  onAccept: () => void;
  label: string;
};

export function SingleDatePickerFooter({ onAccept, label }: SingleDatePickerFooterProps) {
  return (
    <div className={styles.actions}>
      <Button onClick={onAccept} size="S">
        {label}
      </Button>
    </div>
  );
}
